import { Schema } from "effect";
export class StripeProduct extends Schema.Class("open-revenue-stripe-StripeProduct")({
    id: Schema.String,
    name: Schema.String,
    description: Schema.String.pipe(Schema.NullOr),
    active: Schema.Boolean
}) {
}
